import { render, staticRenderFns } from "./labelDetailsDrawer.vue?vue&type=template&id=68029f83&scoped=true"
import script from "./labelDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./labelDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./labelDetailsDrawer.vue?vue&type=style&index=0&id=68029f83&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68029f83",
  null
  
)

export default component.exports